module.exports = __webpack_public_path__ + "static/assets/296357261fb7d74c06765aadb0ff1026.svg";